import React from 'react';
import './Modal.css';

const Modal = ({ 
  children, 
  isOpen, 
  onClose, 
  className = '',
  size = 'md',
  ...props 
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className={`modal-content modal-content--${size} ${className}`} {...props}>
        {children}
      </div>
    </div>
  );
};

export default Modal;